<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerpt0101" class="chapter" epub:type="part" id="pt01" role="doc-part">
<header id="headerpt0101">
<h1 class="pn"><span aria-label="1" class="page" epub:type="pagebreak" id="p1" role="doc-pagebreak"></span><a class="xref" href="#/chiguillory0005#rpt01">[Part One]</a></h1>
<h1 class="pt">The Formation and Deformation of Literary Study</h1>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-guillory-0007.vue?7ea5596c